import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { CASE_STUDIES } from "../data/content";

export const CaseStudies = () => (
  <section id="work" data-testid="case-studies-section" className="relative max-w-7xl mx-auto px-5 sm:px-8 py-20 sm:py-28">
    <p className="font-mono2 text-xs sm:text-sm tracking-[0.25em] text-[#A3E635] uppercase mb-4">
      // Proof, not promises
    </p>
    <h2 className="font-heading text-3xl sm:text-5xl lg:text-6xl font-extrabold uppercase tracking-tight leading-[1.0] mb-4">
      Hard numbers.<br /><span className="text-[#A3E635]">Zero fluff.</span>
    </h2>
    <p className="text-base sm:text-lg text-slate-400 max-w-xl leading-relaxed mb-16">
      Unfiltered ROAS, explosive revenue scaling, and audience acquisition breakdowns from real campaigns.
    </p>

    <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
      {CASE_STUDIES.map((c, i) => (
        <motion.article
          key={c.id}
          data-testid={`case-study-card-${c.id}`}
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-40px" }}
          transition={{ duration: 0.65, delay: i * 0.12, ease: [0.22, 1, 0.36, 1] }}
          className="trace-card group relative rounded-2xl border border-white/10 bg-[#121519]/80 overflow-hidden flex flex-col"
        >
          <div className="relative h-52 overflow-hidden">
            <img
              src={c.image}
              alt={c.client}
              loading="lazy"
              className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-110"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[#121519] via-transparent to-transparent" />
            <span className="absolute top-4 left-4 rounded-full bg-black/70 backdrop-blur px-3 py-1 font-mono2 text-[10px] tracking-[0.2em] uppercase text-[#A3E635] border border-[#A3E635]/30">
              {c.category}
            </span>
          </div>

          <div className="p-7 flex flex-col flex-1">
            <div className="flex items-center justify-between mb-5">
              <h3 className="font-heading text-2xl font-extrabold tracking-tight">{c.client}</h3>
              <ArrowUpRight size={20} className="text-slate-600 group-hover:text-[#A3E635] group-hover:translate-x-1 group-hover:-translate-y-1 transition-all duration-500" />
            </div>

            <div className="grid grid-cols-3 gap-2 mb-5">
              {c.metrics.map((m) => (
                <div key={m.label} className="rounded-lg border border-white/10 bg-black/40 p-2.5 text-center overflow-hidden">
                  <div className="font-heading text-xs sm:text-sm font-extrabold text-[#A3E635] whitespace-nowrap">{m.value}</div>
                  <div className="font-mono2 text-[9px] tracking-[0.15em] uppercase text-slate-500 mt-1">{m.label}</div>
                </div>
              ))}
            </div>

            <p className="text-sm text-slate-400 leading-relaxed mt-auto">{c.highlight}</p>
          </div>
        </motion.article>
      ))}
    </div>

    <p className="mt-10 text-center font-mono2 text-xs tracking-[0.25em] uppercase text-slate-500">
      This could be <span className="text-[#A3E635]">you next</span> — your growth, our mission
    </p>
  </section>
);
